export default "__VITE_ASSET__DZTCWVnJ__"